<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4"></div>
    </base-header>

    <!-- user accounts -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-8">
          <users-table></users-table>
        </div>
        <div class="col-xl-4">
          <user-form></user-form>
        </div>
      </div>
    </div>
    <!-- End user accounts -->
  </div>
</template>
<script>
// Components
import UsersTable from "./UsersTable";
import UserForm from "./UserForm";

export default {
  components: {
    UsersTable,
    UserForm
  }
};
</script>
<style></style>
